import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface EvaluatingToolbarProps {
  count: number | undefined;
  onAddCustom: () => void;
}

const getCountLabel = (count: number | undefined): string => {
  if (count === undefined) return '';

  return `${count} ${count === 1 ? 'element' : 'elements'} under evaluation`;
};

const EvaluatingToolbar = ({ count, onAddCustom }: EvaluatingToolbarProps) => (
  <div className="mb-3 flex items-end justify-between">
    <p className="text-sm text-gray-700" data-testid="evaluating-count">
      {getCountLabel(count)}
    </p>
    <Button
      variant="reserve-outlined"
      size="md"
      iconBefore={<Icons.Plus aria-hidden="true" />}
      onClick={onAddCustom}
      data-testid="add-custom-button"
    >
      Add custom
    </Button>
  </div>
);

export default EvaluatingToolbar;
